import React from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  ContainerButton,
  ContainerDescription,
  ContainerTitle,
  Modal,
} from './styles';

const MaximumTimeModal = (props) => {
  const { onClose } = props;
  return (
    <Modal
      size="mini"
      closeOnEscape
      closeOnDimmerClick
      open
      onClose={onClose}
    >
      <ContainerTitle>
        Your highlight reel is too long!
      </ContainerTitle>

      <ContainerDescription>
        Highlight reels should be under 45 minutes
      </ContainerDescription>

      <ContainerButton>
        <Button onClick={onClose}>
          OK
        </Button>
      </ContainerButton>

    </Modal>
  );
};

MaximumTimeModal.propTypes = {
  onClose: PropTypes.func.isRequired,
};

export default MaximumTimeModal;
